module.exports = __webpack_public_path__ + "4c77e88f34c72f1bec01881851fec290.pdf";